import React from 'react';
import PropTypes from 'prop-types';
import InputField from 'components/pure/utils/form/InputField';
import FieldContainer from '../../utils/form/FieldContainer';
import './CallRecordingLink.styl';
import LiveCoachingActions from 'actions/scorecards/LiveCoachingActions';

export default class CallRecordingLink extends React.PureComponent {
  static propTypes = {
    callRecordingLink: PropTypes.string,
    isEditing: PropTypes.bool,
  };

  linkField() {
    const {callRecordingLink, isEditing} = this.props;
    if (isEditing) {
      return (
        <InputField value={callRecordingLink} onChange={LiveCoachingActions.setCallRecordingLink} />
      );
    }
    if (callRecordingLink) {
      // Link should open in a new tab to avoid losing user's state by navigating away mid-review.
      return (
        <a className="generic-link" href={callRecordingLink} target="_blank" rel="noreferrer">
          Call Recording
        </a>
      );
    }
    return 'N/A';
  }

  render() {
    const linkField = this.linkField();

    return (
      <div className="call-recording-link-wrapper">
        <FieldContainer labelType="div" label="Call Recording Link">
          {linkField}
        </FieldContainer>
      </div>
    );
  }
}
